import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { getOnePeopleById } from "../../config/WeChatPeopleConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class loveStoryShareItem extends cc.Component {

    @property({type:cc.Sprite,displayName:"头像图片节点"})
    headSp:cc.Sprite = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;
    @property({type:cc.Label,displayName:"内容"})
    lbContent : cc.Label = null;


    private _bindPeople:string = "";

    selectFun:(item:loveStoryShareItem)=>void = null;

    bindData(peopleId:string,selectFun:(item:loveStoryShareItem)=>void){
        this._bindPeople = peopleId;
        this.selectFun = selectFun;
        this.updateItem();
    }

    async updateItem(){
        let people = getOnePeopleById(this._bindPeople);
        let headUrl:string = people.headUrl;
        let name:string = people.name;
        this.lbName.string = name;
        let bundle = await getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle);

        switch ( name ) {
            case "沈瑶瑶": this.lbContent.string = "我们见过吗？" ;break;
            case "小芳": this.lbContent.string = "咋啦？" ;break;
            case "薇薇": this.lbContent.string = "宝宝，好久不见" ;break;
        }

        bundle.load(headUrl,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.log("加载头像失败 # loveStoryShareItem",err);
                return;
            }
            this.headSp.spriteFrame = spr;
        });
    }

    getBindPeople(){
        return this._bindPeople;
    }

    onBtnMe(){
        this.selectFun && this.selectFun(this);
    }

}
